<template>
    <div class="row justify-content-center">
        <div class="col-4 col-sm-2 mb-3" v-if="loadingStates.recommendations">
          <Loading/>
        </div>
        <div class="col-12" v-if="!loadingStates.recommendations">
          <div class="mb-2" v-if="recommendedWords && recommendedWords.length">Here are some words suggestions for you:</div>
          <span v-bind:key="word"
               v-for="word in recommendedWords"
               class="pl-2 pr-5 pb-1 mr-3 mb-3 word-pill primary-font d-inline-block">
              {{word}}
              <button class="btn btn-link p-0 m-0 d-inline-flex align-items-center justify-content-center"
                      v-on:click="addSuggestion(word)">
                  <SvgIcon icon="plus" class="icon-sm icon-add" title="add to the list"/>
              </button>
          </span>
        </div>
    </div>
</template>

<script>
    import uuidMixin from '../mixins/uuid.mixin';
    import {mapState} from 'vuex';
    import SvgIcon from './SvgIcon';
    import Loading from '@/components/Loading';

    export default {
        mixins: [uuidMixin],
        name: "WordsSuggestions",
        components: {
            SvgIcon,
            Loading
        },
        computed: {
            ...mapState([
                'words',
                'recommendedWords',
                'loadingStates'
            ])
        },
        methods: {
            addSuggestion(word) {
                this.$store.commit('ADD_SUGGESTION', {word: {word:word, uuid: this.uuidv4()}});
            },
        }
    }
</script>

<style scoped lang="scss">
    .word-pill {
        background-color: rgba($primary, .5);
        color: $black;
        border-radius: 4px;
        position: relative;
        padding-top: .1rem;
        padding-bottom: .1rem;
    }

    .btn {
        position: absolute;
        height: 100%;
        width: 1.5rem;
        top: 0;
        right: .5rem;
    }

    .icon-add {
        stroke: $black;
    }
</style>
